import React, { Component } from 'react';

import { InputBase, styled } from '@mui/material';
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material';

const styles = {
  searchIcon: {
    color: '#BAC8CC',
    height: 20,
  },
  closeIcon: {
    color: '#BAC8CC',
    cursor: 'pointer',
    height: 20,
  },
  textField: {
    hint: {
      color: '#BAC8CC',
      fontWeight: 'normal',
    },
  },
  searchTextField: {
    root: {
      padding: '5px',
      width: '100%',
      fontSize: 12,
    },
    input: {
      // textAlign: 'right'
    },
    inputHint: {
      fontSize: 12,
      color: '#ADBDCC',
      lineHeight: '24px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // width: '85%',
      height: 'auto',
    },
  },
};

const muiStyles = {
  inputBase: {
    fontSize: 12,
    '.MuiInputBase-input': {
      padding: '3px 0',
    },
  },
};

const StyledInputBase = styled(InputBase)(muiStyles.inputBase);

class VideoListSearch extends Component {
  _onSearchTextChanged = (e) => {
    const { onChange } = this.props;
    e.preventDefault();
    onChange(e.target.value);
  };

  _onSearchTextCleared = (e) => {
    const { onChange } = this.props;
    e.preventDefault();
    onChange('');
  };

  render() {
    const { searchText } = this.props;
    const inputText = searchText && searchText !== '' ? searchText : '';
    return (
      <div className="search-row">
        <div className="search-container">
          <StyledInputBase
            type="text"
            fullWidth={true}
            placeholder="Search for videos"
            margin="dense"
            inputProps={{
              autoComplete: 'new-password',
            }}
            autoFocus={true}
            onChange={this._onSearchTextChanged}
            value={inputText}
          />
          {searchText.length ? (
            <CloseIcon
              fontSize="large"
              style={styles.closeIcon}
              onClick={this._onSearchTextCleared}
            />
          ) : (
            <SearchIcon fontSize="large" style={styles.searchIcon} />
          )}
          {/* {inputText !== '' && (
            <CloseIcon
              fontSize="large"
              style={styles.closeIcon}
              onClick={this._onSearchTextCleared}
            />
          )} */}
          {/* <SearchIcon fontSize="large" style={styles.searchIcon} /> */}
        </div>
      </div>
    );
  }
}

VideoListSearch.defaultProps = {
  searchText: '',
  onChange: () => {},
};

export default VideoListSearch;
